angular.module('webpanel').filter('html', function($sce) {
	return $sce.trustAsHtml;
});